import React, { useState, useEffect } from 'react';
import { getAllBlogs } from '../../utils/api';
import { useHistory } from 'react-router-dom';
import './BlogCards.css';

// Blog resim URL'sini düzeltmek için yardımcı fonksiyon
const getBlogImageUrl = (blog) => {
  // Eğer resim yoksa boş döndür
  if (!blog.image) return '';
  
  // Eğer zaten tam URL ise, olduğu gibi döndür
  if (blog.image.startsWith('http://') || blog.image.startsWith('https://')) {
    return blog.image;
  }
  
  // Blog resimleri için doğru URL'yi oluştur
  const baseUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://mayadangayrimenkul.com.tr';
  const fullUrl = `${baseUrl}/upload/blog/${blog.image}`;
  
  return fullUrl;
};

// Resim yüklenme hatası için placeholder
const handleImageError = (event) => {
  event.target.style.display = 'none';
  const placeholder = event.target.parentNode.querySelector('.blog-placeholder-image');
  if (placeholder) {
    placeholder.style.display = 'flex';
  }
};

const BlogCards = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const data = await getAllBlogs();
      // Sadece ilk 3 blog'u göster
      setBlogs(data.slice(0, 3));
      setLoading(false);
    } catch (error) {
      console.error('Blog yüklenirken hata:', error);
      setLoading(false);
    }
  };

  const handleBlogClick = (blog) => {
    // Blog detay sayfasına yönlendir
    history.push(`/blog/${blog.id}`);
  };

  if (loading) {
    return (
      <div className="blog-cards-loading">
        <div className="loading-spinner"></div>
        <p>Bloglar yükleniyor...</p>
      </div>
    );
  }

  if (blogs.length === 0) {
    return null; // Blog yoksa hiçbir şey gösterme
  }

  return (
    <section className="blog-cards-section">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 dark:text-slate-300 mb-4">Blog Yazılarımız</h2>
          <p className="text-gray-600 dark:text-slate-300 text-lg">
            Gayrimenkul dünyasından en güncel bilgiler ve ilham verici içerikler
          </p>
        </div>

        {/* Blog Cards */}
        <div className="blog-cards-grid">
          {blogs.map((blog) => (
            <div key={blog.id} className="blog-card-home" onClick={() => handleBlogClick(blog)}>
              <div className="blog-card-image">
                {blog.image ? (
                  <>
                    <img 
                      src={getBlogImageUrl(blog)} 
                      alt={blog.title} 
                      onError={handleImageError}
                    />
                    <div className="blog-placeholder-image" style={{ display: 'none' }}>
                      <span>Resim Yok</span>
                    </div>
                  </>
                ) : (
                  <div className="blog-placeholder-image">
                    <span>Resim Yok</span>
                  </div>
                )}
              </div>
              <div className="blog-card-content">
                <h3>{blog.title}</h3>
                <p className="blog-excerpt">
                  {blog.content.replace(/<[^>]*>/g, '').substring(0, 120)}...
                </p>
                <div className="blog-meta">
                  <span className="blog-date">
                    {new Date(blog.created_at).toLocaleDateString('tr-TR')}
                  </span>
                  <span className="blog-author">{blog.author}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Tümünü Gör Butonu */}
        <div className="text-center mt-8">
          <button 
            onClick={() => history.push('/blog')}
            className="bg-[#EFBB4C] hover:bg-[#d4a63f] text-[#252836] font-semibold py-3 px-8 rounded-lg transition-colors duration-200"
          >
            Tüm Blog Yazılarını Gör
          </button>
        </div>
      </div>
    </section>
  );
};

export default BlogCards;
